import { PropsWithChildren } from "react";
import Breadcrumb from "../breadcrumb/breadcrumb";
import "./work-area.scss";

interface WorkAreaHeaderProps {
	path: string[]
}

interface WorkAreaContentProps {
	title: string;
}

type WorkAreaProps = WorkAreaHeaderProps & WorkAreaContentProps;

const WorkAreaHeader = ({ path }: WorkAreaHeaderProps) => {
	return (
		<header className="main-header  main-headerComercios">
			<div className="row">
				<div className="col-9">
					<Breadcrumb path={path} />
				</div>
			</div>
		</header>
	);
};

const WorkAreaContent = ({ title, children }: PropsWithChildren<WorkAreaContentProps>) => {
	return (
		<article className="main-content">
			<div className="container-fluid">
				<div className="row mt-3">
					<div className="col-auto">
						<h4 className="main-content-title">{title}</h4>
					</div>
				</div>
				<div className="row">
					<div className="col-12">
						{children}
					</div>
				</div>
			</div>
		</article>
	);
};

const WorkArea = ({ title, path, children }: PropsWithChildren<WorkAreaProps>) => {
	return (
		<>
			<WorkAreaHeader path={path} />
			<WorkAreaContent title={title}>
				{children}
			</WorkAreaContent>
		</>
	);
};

export default WorkArea;